import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const endpoints = {
  config: () => api.get("/config").then((r) => r.data),
  tags: () => api.get("/tags").then((r) => r.data),
  projects: (params) => api.get("/projects", { params }).then((r) => r.data),
  project: (slug) => api.get(`/projects/${slug}`).then((r) => r.data),
  event: (body) => api.post("/events", body).then((r) => r.data),
  pledge: (body) => api.post("/support/pledge", body).then((r) => r.data),
  inkind: (body) => api.post("/support/inkind", body).then((r) => r.data),
  message: (body) => api.post("/support/message", body).then((r) => r.data),
  requestLink: (body) => api.post("/auth/request", body).then((r) => r.data),
  verify: (token) => api.post("/auth/verify", { token }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  signout: () => api.post("/auth/signout").then((r) => r.data),
  mySupport: (device_id) => api.get("/me/support", { params: { device_id } }).then((r) => r.data),
  adminOverview: () => api.get("/admin/overview").then((r) => r.data),
  adminProjects: () => api.get("/admin/projects").then((r) => r.data),
  adminVisibility: (id, is_visible) => api.patch(`/admin/projects/${id}/visibility`, { is_visible }).then((r) => r.data),
  adminSubmissions: (type, params) => api.get("/admin/submissions", { params: { type, ...params } }).then((r) => r.data),
  adminUpdate: (type, id, body) => api.patch(`/admin/submissions/${type}/${id}`, body).then((r) => r.data),
  adminExportUrl: (type) => `${API}/admin/export?type=${type}`,
  adminContacts: () => api.get("/admin/contacts").then((r) => r.data),
  adminContactsImport: (csv) => api.post("/admin/contacts/import", { csv }).then((r) => r.data),
  adminDigestPreview: () => api.get("/admin/digests/preview").then((r) => r.data),
  adminDigestSend: () => api.post("/admin/digests/send").then((r) => r.data),
  adminGetProject: (id) => api.get(`/admin/projects/${id}`).then((r) => r.data),
  builderGetProject: (id) => api.get(`/builder/projects/${id}`).then((r) => r.data),
  adminEditProject: (id, body) => api.patch(`/admin/projects/${id}`, body).then((r) => r.data),
  adminUploadHero: (id, file, kind = "page") => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/admin/projects/${id}/hero?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  adminClearHero: (id, kind = "page") => api.delete(`/admin/projects/${id}/hero?kind=${kind}`).then((r) => r.data),
  adminAdmins: () => api.get("/admin/admins").then((r) => r.data),
  adminUpsertAdmin: (body) => api.post("/admin/admins", body).then((r) => r.data),
  adminRemoveAdmin: (email) => api.delete(`/admin/admins/${encodeURIComponent(email)}`).then((r) => r.data),
  gallery: () => api.get("/gallery").then((r) => r.data),
  adminGalleryUpload: (file, caption = "") => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/admin/gallery?caption=${encodeURIComponent(caption)}`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  adminGalleryUpdate: (id, body) => api.patch(`/admin/gallery/${id}`, body).then((r) => r.data),
  adminGalleryDelete: (id) => api.delete(`/admin/gallery/${id}`).then((r) => r.data),
  builderMe: () => api.get("/builder/me").then((r) => r.data),
  builderEditProject: (id, body) => api.patch(`/builder/projects/${id}`, body).then((r) => r.data),
  builderUploadHero: (id, file, kind = "page") => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/builder/projects/${id}/hero?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  builderClearHero: (id, kind = "page") => api.delete(`/builder/projects/${id}/hero?kind=${kind}`).then((r) => r.data),
  builderInbox: (id, type) => api.get(`/builder/projects/${id}/inbox`, { params: { type } }).then((r) => r.data),
  profileMe: () => api.get("/profile/me").then((r) => r.data),
  profileUpdate: (body) => api.put("/profile", body).then((r) => r.data),
  profilePhoto: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/profile/photo", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  profilePhotoClear: () => api.delete("/profile/photo").then((r) => r.data),
};
